import React from 'react'
import { TextMediumSM } from '../../../../../Components/Text/MediumText'
import InspectionTypeSchedule from './InspectionType'
import StatusSchedule from './Status'
import ScheduleTypeSchedule from './ScheduleType'
import { CalendarCheck } from 'lucide-react'
import { HeadingWithIcon } from '../../../../../Components/Utils/Settingheading'

function ScheduleSettings() {
    return(
        <>
        
                     <HeadingWithIcon icon={CalendarCheck} title="Schedule" />

        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
        
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <InspectionTypeSchedule/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <ScheduleTypeSchedule/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <StatusSchedule/>
         </div>
        
       
         </div>
         </>
    )
}

export default ScheduleSettings
